const DOCUMENT = 'REMOVE_MULTIDAY_WORKER_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_AFTER_ACTION: DOCUMENT + 'LOAD_AFTER_ACTION',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  CHANGE_CHECKED: DOCUMENT + 'CHANGE_CHECKED',
  UNASSIGN: DOCUMENT + 'UNASSIGN',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),

  changeChecked: data => ({
    type: actions.CHANGE_CHECKED,
    payload: data,
  }),

  unassign: data => ({
    type: actions.UNASSIGN,
    payload: data,
  }),
};

export default actions;
